<section [ngClass]="['card', sectionClasses || 'mx-n3 mx-sm-auto']">
    <header [class]="['card-header', headerClasses]">
        <h3 [class]="h3Class || 'mb-0'">{{ title }}</h3>
    </header>
    <div [class]="['card-description', descriptionClasses]">
        <h5 [class]="h5Class">{{ description }}</h5>
    </div>
    <main [ngClass]="['card-body', cardBodyClasses || '']">
        <ng-content></ng-content>
        <div class="top-right-container">
            <ng-content select=".top-right-content"></ng-content>
        </div>
    </main>
</section>
